import React from "react";

const isBrowserExtensionNoise = (value) => {
  const text = String(value?.stack || value?.message || value || "");
  return /chrome-extension:\/\/|moz-extension:\/\/|safari-web-extension:\/\/|Failed to connect to MetaMask/i.test(text);
};

export default function ConsolePrivacyGuard() {
  React.useEffect(() => {
    const stopBrowserExtensionError = (event, value) => {
      if (!isBrowserExtensionNoise(value)) return;
      event.preventDefault();
      event.stopImmediatePropagation?.();
      event.returnValue = false;
    };

    const handleUnhandledRejection = (event) => {
      stopBrowserExtensionError(event, event.reason);
    };

    const handleWindowError = (event) => {
      stopBrowserExtensionError(event, event.error || event.message);
    };

    window.addEventListener("unhandledrejection", handleUnhandledRejection);
    window.addEventListener("error", handleWindowError);

    const originalError = console.error;
    const originalWarn = console.warn;
    const sanitize = (arg) => {
      if (isBrowserExtensionNoise(arg)) return "[browser extension error ignored]";
      if (typeof arg !== "string") return "[redacted]";
      return arg
        .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, "[email]")
        .replace(/\+?\d[\d\s().-]{7,}\d/g, "[phone]")
        .replace(/token|secret|password|authorization/gi, "[secret]");
    };

    console.error = (...args) => {
      if (args.some(isBrowserExtensionNoise)) return;
      originalError(...args.map(sanitize));
    };
    console.warn = (...args) => {
      if (args.some(isBrowserExtensionNoise)) return;
      originalWarn(...args.map(sanitize));
    };

    return () => {
      window.removeEventListener("unhandledrejection", handleUnhandledRejection);
      window.removeEventListener("error", handleWindowError);
      console.error = originalError;
      console.warn = originalWarn;
    };
  }, []);

  return null;
}